(() => {
  if (window.z12HoverVideosReady) return;
  window.z12HoverVideosReady = true;
  let active = null;
  const api = () => {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (window.z12HoverYouTubeAPI) return window.z12HoverYouTubeAPI;
    window.z12HoverYouTubeAPI = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      const timer = setTimeout(() => reject(new Error('YouTube API timeout')), 15000);
      window.onYouTubeIframeAPIReady = () => {
        try { previous?.(); } finally { clearTimeout(timer); resolve(window.YT); }
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api'; script.async = true;
        script.addEventListener('error', () => { clearTimeout(timer); reject(new Error('YouTube API unavailable')); }, { once: true });
        document.head.append(script);
      }
    });
    return window.z12HoverYouTubeAPI;
  };
  const init = root => {
    if (!root.isConnected || root.z12HoverCleanup) return;
    const button = root.querySelector('[data-z12n-hover-toggle]');
    const mount = root.querySelector('[data-z12n-video-mount]');
    const template = root.querySelector('[data-z12n-video-template]');
    if (!button || !mount || !template) return;
    const abort = new AbortController(), options = { signal: abort.signal };
    let player = null, timer = null, generation = 0, wanted = false, resume = 0;
    const inView = () => { const rect = root.getBoundingClientRect(); return rect.bottom > 0 && rect.top < innerHeight; };
    const state = playing => {
      root.classList.toggle('is-playing', playing);
      root.classList.toggle('is-video-playing', playing);
      button.hidden = false; button.setAttribute('aria-pressed', String(playing));
      root.querySelectorAll('[data-z12n-video-poster]').forEach(poster => { poster.hidden = playing; });
    };
    const stop = (keepTime = false) => {
      clearTimeout(timer); generation++; wanted = false;
      window.z12ReleaseMedia?.(root);
      if (keepTime && player?.getCurrentTime) resume = player.getCurrentTime() || 0;
      else resume = 0;
      if (player) { try { player.stopVideo?.(); player.destroy?.(); } catch (_) {} player = null; }
      mount.replaceChildren(); state(false);
      if (active === stop) active = null;
    };
    const start = async () => {
      clearTimeout(timer);
      if (wanted || document.hidden || !root.isConnected || !inView()) return;
      if (active && active !== stop) active();
      window.z12ClaimMedia?.(root, stop);
      active = stop; wanted = true; const token = ++generation;
      try {
        const YT = await api();
        if (generation !== token || !wanted || document.hidden || !root.isConnected || !inView()) return;
        const source = template.content.querySelector('iframe');
        const id = root.dataset.z12nHoverVideo;
        if (!source || !id) { stop(); return; }
        const target = document.createElement('div'); mount.replaceChildren(target);
        player = new YT.Player(target, {
          host: 'https://www.youtube-nocookie.com',
          videoId: id,
          playerVars: { controls: 0, autoplay: 0, playsinline: 1, rel: 0, origin: location.origin },
          events: {
            onReady: event => {
              if (generation !== token) { event.target.destroy?.(); return; }
              if (!wanted || document.hidden || !inView()) { stop(); return; }
              event.target.mute();
              if (resume) event.target.seekTo(resume, true);
              event.target.playVideo();
              const frame = event.target.getIframe();
              frame.setAttribute('title', source.title || '');
              frame.setAttribute('tabindex','-1');
              frame.setAttribute('allow','autoplay; encrypted-media; picture-in-picture; fullscreen');
            },
            onStateChange: event => {
              if (generation !== token) return;
              if (event.data === 1) state(true);
              else if (event.data === 0) stop();
              else if (event.data === 2) stop(true);
              else root.classList.remove('is-video-playing');
            },
            onError: () => { if (generation === token) stop(); },
            onAutoplayBlocked: () => { if (generation === token) stop(); }
          }
        });
      } catch (_) { if (generation === token) stop(); }
    };
    root.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      clearTimeout(timer); timer = setTimeout(start, 180);
    }, options);
    root.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') stop();
    }, options);
    button.addEventListener('click', event => { event.preventDefault(); wanted ? stop(true) : start(); }, options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); }, options);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => !entry.isIntersecting || entry.intersectionRatio <= .05)) stop();
      }, { threshold: [0, .05] });
      observer.observe(root);
    } else {
      window.addEventListener('scroll', () => { if (!inView()) stop(); }, { ...options, passive: true });
    }
    root.z12HoverCleanup = () => { stop(); abort.abort(); observer?.disconnect(); delete root.z12HoverCleanup; };
  };
  const boot = (scope = document) => {
    if (scope.matches?.('[data-z12n-hover-video]')) init(scope);
    scope.querySelectorAll('[data-z12n-hover-video]').forEach(init);
  };
  const unload = scope => {
    if (scope.matches?.('[data-z12n-hover-video]')) scope.z12HoverCleanup?.();
    scope.querySelectorAll('[data-z12n-hover-video]').forEach(root => root.z12HoverCleanup?.());
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot(), { once: true }) : boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
})();